<template>
  <div id="product-reference-plugin product-reference-plugin--manfuacturer-part">
    <Spin v-if="loading"></Spin>
    <div v-else>
      <h4>{{ $t('part.title') }}</h4>
      <div v-if="addPartVisible" class="manufacturePartPickerContainer">
        <ManufacturerPartPicker @on-changed="handleManufacturerPartChanged"></ManufacturerPartPicker>
        <div class="text-align-right">{{ $t('product.reference_assembled_part_help_text') }}<a @click="setEnabled">{{
            $t('change')
        }}</a></div>
      </div>
      <div class="manufacturers-parts-selected">
        <div style="margin: 0.63rem 0" class="manufacturers-part" v-for="mp in manufacturerPartList" :key="mp.id">
          <router-link :to="getPartMenuTarget(mp)" target="_blank">
           {{`[${mp.part_identity ? mp.part_identity.part_number : ''}]` }} {{ mp.name || mp.chinese_name }}
          </router-link>

          <template>
            <Icon v-if="mp && mp.id" type="ios-close" @click="deleteModal = true" />
            <Modal v-model="deleteModal" width="360">
              <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle" style="margin-right: 10px;"></Icon>
                <span>
                  {{ $t('product.plugins.manufacturer_part.remove_modal.title') }}
                </span>
              </p>
              <div style="text-align:center">
                <p>
                  {{ $t('product.plugins.manufacturer_part.remove_modal.warning') }}
                </p>
                <br>
                <p>
                  {{ $t('product.plugins.manufacturer_part.remove_modal.confirm') }}
                </p>
              </div>
              <div slot="footer">
                <Button type="error" size="large" long :loading="deleteModalLoading" @click="handleRemove($e, mp.id)">
                  {{ $t('product.plugins.manufacturer_part.remove_modal.button_text') }}
                </Button>
              </div>
            </Modal>
          </template>
        </div>
      </div>

      <div class="margin-top-20" v-if="manufacturerPart.component_type === 'assembled_part'">
        <h4>BOM</h4>
        <div v-if="bom && Object.entries(bom).length > 0">
          <router-link :to="{ name: 'menu.bom.view', params: { bomId: bom.id } }" target="_blank">[{{
              $t(`bom_tool.${bom.setting.bom_type}`)
          }}][{{ bom.is_draft ? $t('bom_tool.editing') : bom.version }}] {{
    bom.name
}}</router-link>
        </div>
        <span v-else>{{ $t('product.plugins.manufacturer_part.has_no_bom_message') }}</span>
      </div>
      <div class="text-align-right margin-top-20" v-if="product && !manufacturerPart.id">
        <router-link to="#" @click.native="displayAddPartInput">
          {{ $t('product.plugins.manufacturer_part.add_new_part') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import ManufacturerPartPicker from '@/view/part/components/manufacturer-part-picker'

export default {
  name: 'ProductManufacturerpartPlugin',
  components: {
    ManufacturerPartPicker
  },
  props: {
    product: {
      required: true
    }
  },
  data() {
    return {
      manufacturer_part_id: null,
      manufacturerPartList: [],
      manufacturerPart: {},
      bom: {},
      pluginName: 'manufacturerPart',
      loading: false,
      disabled: false,
      addPartVisible: true,
      deleteModal: false,
      deleteModalLoading: false
    }
  },
  computed: {
    productId: function () {
      return this.product ? this.product.id : null
    }
  },
  mounted() {
    if (this.productId) {
      this.loadPluginData(this.pluginName, this.productId)
    }
  },
  methods: {
    ...mapActions([
      'getProductReferencePluginData',
      'setProductReferencePluginData',
      'deleteProductReferencePluginData'
    ]),
    moment,
    loadPluginData(pluginName, productId) {
      this.loading = true
      this.getProductReferencePluginData({ plugin: pluginName, productId: productId }).then(resp => {
        this.manufacturerPartList = resp.data && Object.entries(resp.data).length > 0 ? resp.data.manufacturer_parts : []
        this.bom = resp.data && Object.entries(resp.data).length > 0 ? resp.data.bom : {}
        this.addPartVisible = this.manufacturerPartList.length === 0
      }).finally(() => {
        this.loading = false
      })
    },
    setPluginData(pluginName, productId, data) {
      this.loading = true
      this.setProductReferencePluginData({ plugin: pluginName, productId: productId, data: data }).then((resp) => {
        this.manufacturerPartList = resp.data && Object.entries(resp.data).length > 0 ? resp.data.manufacturer_parts : []
        this.bom = resp.data && Object.entries(resp.data).length > 0 ? resp.data.bom : {}
        this.addPartVisible = this.manufacturerPartList.length === 0
      }).finally(() => {
        this.loading = false
      })
    },
    displayAddPartInput() {
      this.addPartVisible = true
    },
    setEnabled() {
      this.disabled = false
    },
    handleManufacturerPartChanged(selectedPart) {
      if (selectedPart) {
        this.setPluginData(this.pluginName, this.productId, { manufacturer_part_id: selectedPart.id })
      }
    },
    handleRemove(event, manufacturerPartId) {
      this.deleteModalLoading = true
      setTimeout(() => {

      }, 2000)
      const data = {
        manufacturer_part_id: manufacturerPartId
      }
      this.deleteProductReferencePluginData({ plugin: this.pluginName, productId: this.productId, data: data })
        .then((resp) => {
          if (resp.data.success) {
            this.deleteModalLoading = false
            this.deleteModal = false
            this.$Message.success('Manufacturer part removed successfully')
            this.loadPluginData(this.pluginName, this.productId)
          }
        })
    },
    getPartMenuTarget(manufacturerPart) {
      const partType = manufacturerPart.component_type === 'circuit_board' ? 'pcb' : manufacturerPart.component_type
      return { name: `menu.${partType}.edit`, params: { partId: manufacturerPart.id } }
    }
  },
  watch: {
    productId: function (newProdId, oldProdId) {
      if (newProdId !== oldProdId) {
        this.loadPluginData(this.pluginName, newProdId)
      }
    }
  }
}
</script>
